import { Env, getEnvFromHostname } from '@drayalliance/utils';

export enum Service {
  /** Admin-Service
   * - Request will be routed to the appropriate deployment of *Admin-Service* matching the environment *DMS* is running in.
   * NOTE: Currently Admin is a sub-service in the Hub-Service Modular Monolith
   * */
  ADMINISTRATION = 'ADMIN-SERVICE',
  /** GPS-Service
   * - Request will be routed to the appropriate deployment of *GPS-Service* matching the environment *DMS* is running in.
   * */
  GPS = 'GPS'
}

const SERVICE_BASE: Record<Env, string> = {
  [Env.Production]: 'https://api.drayalliance.com',
  [Env.Stage]: 'https://api.stage.drayalliance.com',
  [Env.Test]: 'https://api.test.drayalliance.com',
  [Env.Local]: 'http://localhost:3000'
};

const SERVICE_PATH: Record<Service, Record<Env, string>> = {
  [Service.ADMINISTRATION]: {
    [Env.Production]: '/admin',
    [Env.Stage]: '/admin',
    [Env.Test]: '/admin',
    [Env.Local]: '/admin'
  },
  [Service.GPS]: {
    [Env.Production]: '/gps',
    [Env.Stage]: '/gps',
    [Env.Test]: '/gps',
    [Env.Local]: '/gps'
  }
};

export function buildUrl(service: Service, path: string): URL {
  if (!path.startsWith('/')) {
    path = `/${path}`;
  }

  const { env } = getEnvFromHostname(window.location.hostname);

  if (!env) {
    throw new Error('Unable to determine environment');
  }

  const url = new URL(SERVICE_PATH[service][env] + path, SERVICE_BASE[env]);
  return url;
}
